import { zodValidator, type TypedFetch } from "@spiriidk/utils";

import {
  LiveStatusResponseSchema,
  type LiveStatusResponse,
} from "../../schemas/live-status";

async function getLiveStatus(
  fetch: TypedFetch,
  signal?: AbortSignal
): Promise<LiveStatusResponse> {
  return await fetch("/opcenter/live-status", {
    validateResponse: zodValidator(LiveStatusResponseSchema),
    signal,
  });
}

export { getLiveStatus };
